import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { LoadingPlaceholderStyled } from 'components/loader/LoadingPlaceholder.styles';

export const ViewAirbnbGuestReviewModalContainer = styled.div``;

export const OverallRatingStyled = styled.div`
  span {
    font-size: 16px;
    font-weight: 600;
  }

  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ResponseTimeExpiredStyled = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #6c757d;
`;

export const ResponseSubmittedOnStyled = styled.p`
  color: #6c757d;

  text-align: right;
`;

export const ResponseFieldRowStyled = styled(Row)`
  ${LoadingPlaceholderStyled} {
    margin-bottom: 10px;
  }
`;

export const SuggestAResponseColStyled = styled(Col)`
  padding-left: 15px;
`;
